import Vue from "vue";
const Button = () => import("@/components/Button.vue");
export default Vue.extend({
    components: { Button },
    props: {
        loading: Boolean,
        disabled: Boolean,
    },
    data: () => ({
        countdown: 0,
        interval: 0,
    }),
    computed: {
        text() {
            return this.countdown > 0
                ? `Coba lagi dalam: ${this.countdown} detik`
                : `Kirim detail akun ke email pribadi saya`;
        },
    },
    methods: {
        onClick() {
            this.$emit("click");
            this.startTimer();
        },
        startTimer() {
            this.countdown = 30;
            this.interval = setInterval(() => {
                this.countdown--;
                if (this.countdown < 1) {
                    clearInterval(this.interval);
                    this.countdown = 0;
                }
            }, 1000);
        },
    },
});
